import {
  TransformLifeAreaSectionSource,
  transformLifeAreaSectionToGoal as _transformLifeAreaSectionToGoal,
} from '@griply/services';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';
import { chunkArray } from 'shared/utils/chunk-array';

import { getTaskDocs } from './get-tasks';
import { getDatabase } from './helpers';

export const transformLifeAreaSectionToGoal = async (
  sectionId: ID,
  lifeArea: TransformLifeAreaSectionSource,
): Promise<ID | undefined> => {
  const section = lifeArea.sections?.find(({ id }) => id === sectionId);
  if (!section) {
    return undefined;
  }

  const tasks = (
    await Promise.all(
      chunkArray(section.tasks, 30).map((ids) => getTaskDocs({ ids })),
    )
  ).flat(1);

  return _transformLifeAreaSectionToGoal({
    sectionId,
    lifeArea,
    tasks,
    collection,
    doc,
    db: getDatabase(),
    serverTimestamp,
    writeBatch: (db) => writeBatch(db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.TransformLifeAreaSectionToGoal,
        error,
      }),
  });
};
